import $ from "jquery";

$(() => {
  if (document.querySelector('.our-services-tab-list')) {
    const tabList = $('.our-services-tab-list').children('.tab-list').children('.tab-item').children('a');
    const tabBlocks = $('.our-services-tab-list').children('.tabs-container').children('.tab-container');
    // console.log(tabBlocks);
    const mobileTabs = $('.our-services-tab-list').children('.tab-list').children('.tab-item').children('.mobile-tab');

    const clickHandler = (currentTab) => {
      tabList.each((i, tab) => {
        $(tab).removeClass('active-tab');
        if( tab.getAttribute("key") === currentTab.getAttribute("key") ) {
          $(tab).addClass('active-tab');
        }
      });
      tabBlocks.each((i, block) => {
        if( block.getAttribute("key") === currentTab.getAttribute("key") ) {
          $(block).removeClass('hidden');
          $(block).addClass('block');
        } else {
          $(block).removeClass('block');
          $(block).addClass('hidden');
        }
      });
      mobileTabs.each((i, mobileTab) => {
        if( mobileTab.getAttribute("key") === currentTab.getAttribute("key") ) {
          $(mobileTab).addClass('open-tab');
        } else {
          $(mobileTab).removeClass('open-tab');
        }
      });
    }

    tabList.each((i, tab) => {
      $(tab).on("click", () => {
        clickHandler(tab);
      });
    });
  }
});